const types = {
    EVENT: 'gameEvent',
    UPDATE_ROOM_LIST: 'cashUpdateRoomList',
    UPDATE: 'cashUpdate',
    CREATE_ROOM: 'createRoom',
    JOIN_ROOM: 'joinRoom',
    ADD_WAITING_ROOM_PROCESS: 'addWaitingProcess',
    REMOVE_WAITING_PROCESS: 'removeWaitingProcess',
    SET_FILTER:"setFilters",
    RESET_FILTER:"resetFilters",
};
export default types
